<template>
    <div
        :id="id"
        :class="[size]"
        class="tl-text-title"
        :style="`text-align: ${alignment}`"
        v-html="markedContent"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import marked from 'widget-components/utilities/marked'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    content: string
    options?: {
        size?: string
        alignment?: string
    }
}>()

const markedContent = computed(() => marked(props.content))
const size = computed(() => props.options?.size?.toLowerCase() || '')
const alignment = computed(() => props.options?.alignment || '')
</script>

<style lang="sass" scoped>
@import "./TextTitle.sass"
</style>
